import RequestIntakeSettings from '@/pages/settings/request-intake';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/request-intake'
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <RequestIntakeSettings />;
}
